export const GOVGR_ERROR_MESSAGE = "govgr-error-message";
export const GOVGR_VISUALLY_HIDDEN = "govgr-visually-hidden";
export const GOVGR_HINT = "govgr-hint";
export const GOVGR_HEADING_S = "govgr-heading-s";
export const GOVGR_FIELD = "govgr-field";
export const GOVGR_FIELD__ERROR = "govgr-field__error";
export const GOVGR_SELECT = "govgr-select";
export const GOVGR_ERROR_INPUT = "govgr-error-input";
